// Carlos's expertise, laid out as a walk through the field.
// Each beacon is one thing I do, not a resume line.
// Positions are world-space [x, z]; the path meanders forward from spawn (+Z).

export interface Experience {
  id: string;
  title: string;
  org: string;
  year: string;
  role?: string;
  description: string;
  link?: { label: string; url: string };
  color: string;
  position: [number, number]; // [x, z]
}

export const CHECKPOINT_ENTER_RADIUS = 4.5;
export const CHECKPOINT_EXIT_RADIUS = 6.5;

export const EXPERIENCES: Experience[] = [
  {
    id: 'product-design',
    title: 'Senior Product Designer',
    org: 'Apple Design Award Winner',
    year: '16+ years',
    description:
      'I help companies turn designs into revenue. Apple Design Award winner with an MBA. Over 100 brands have grown with my work, from Speechify and WeWork to HP and CryptoKitties, shipped to millions of users.',
    link: { label: 'See the portfolio', url: 'https://lastrescarlos.com/portfolio' },
    color: '#ffb7c5',
    position: [0, 20],
  },
  {
    id: 'software-developer',
    title: 'Software Developer',
    org: 'I ship things myself',
    year: 'Design × Code',
    description:
      'I write code and work hands-on with AI tools. That changes how I make decisions upstream. You stop designing for an idealized product and start designing for what can actually be built, maintained, and grown.',
    color: '#4dc9ff',
    position: [15, 42],
  },
  {
    id: 'tedx-awaji',
    title: 'Awaji TEDx',
    org: '3x TEDx & UN Speaker',
    year: '2025',
    description:
      'Creativity is a skill, not a gift. That was my TEDxAwaji talk, one of three TEDx stages so far, plus speaking at the United Nations. My work has been featured in media across three continents.',
    link: { label: 'Watch the talk', url: 'https://www.youtube.com/watch?v=R8vvIZ817no&t=102s' },
    color: '#ff4d88',
    position: [-12, 64],
  },
  {
    id: 'tedx-tokyo',
    title: 'Tokyo TEDx',
    org: 'The latest talk',
    year: '2026',
    description:
      'Only broken things make us think. Blowing dust from Super Nintendo cartridges taught me that friction forces you to ask why. Seamless AI lets us consume without questioning. Real innovation belongs to those who break things.',
    link: { label: 'Watch the talk', url: 'https://www.youtube.com/watch?v=8y5bXaO1Oi0' },
    color: '#ff6b6b',
    position: [18, 88],
  },
  {
    id: 'glimpse',
    title: 'Glimpse, My AI Vision App',
    org: 'AI Assistant with Eyes',
    year: 'iOS',
    description:
      'Point your camera at anything, ask out loud, and get instant spoken answers. No typing, no menus. Real time vision and voice, designed, built, and shipped by me.',
    link: { label: 'Get Glimpse on the App Store', url: 'https://apps.apple.com/jp/app/glimpse-vision-ai/id6764219526?l=en-US' },
    color: '#9d7bff',
    position: [-16, 112],
  },
  {
    id: 'animaecho',
    title: 'AnimaEcho',
    org: 'A companion on your phone',
    year: 'iOS',
    description:
      'An animated companion who listens when you speak and talks back in her own voice, in real time. Another product I designed, built, and shipped end to end.',
    link: { label: 'View on the App Store', url: 'https://apps.apple.com/jp/app/animaecho/id6781352893' },
    color: '#4dffb8',
    position: [2, 138],
  },
  {
    id: 'ground-control',
    title: 'Ground Control Chat',
    org: 'Your AI agents, in your pocket',
    year: 'iOS · macOS',
    description:
      'Monitor and control your Claude Code sessions from your iPhone. Each agent is a pixel pilot on a neon street. Built because I actually needed it, then shipped for everyone.',
    link: { label: 'View on the App Store', url: 'https://apps.apple.com/us/app/ground-control-chat/id6791229853' },
    color: '#ffa94d',
    position: [22, 164],
  },
  {
    id: 'tokyo',
    title: 'The Tokyo Standard',
    org: 'Craft & languages',
    year: 'Tokyo, Japan',
    description:
      'Living in Tokyo sharpened everything. The standard for craft here is so high that mediocrity stands out immediately. I bring that lens to every product I touch, in Spanish, English, Japanese, and Chinese.',
    color: '#ffe14d',
    position: [-20, 190],
  },
  {
    id: 'lets-talk',
    title: "Let's Talk",
    org: 'lastrescarlos.com',
    year: 'Now',
    description:
      'If you need a designer who understands your business goals, runs data-informed decisions, and delivers work that actually converts, reach out.',
    link: { label: 'Visit lastrescarlos.com', url: 'https://lastrescarlos.com' },
    color: '#ffffff',
    position: [8, 216],
  },
];
